import restCrudActions from '../../../np-crud/store/restCrudActions';
import { getAxiosInstance } from '../../../np-rest/rest';
import { snackActions } from '../../../sc-utilities/SnackBar';

// Create CRUD action creator
const crudActions = restCrudActions({
    endpointBasePath: 'sku-patterns',
    pluginName: 'SETTINGS',
    entityName: 'SKU_PATTERN',
    fetchSuccessMessage: '',
    loadSuccessMessage: '',
});

// Fetch SKU patterns action creators
export const fetchSKUPatternInit = () => {
    return crudActions.fetchInit();
};
export const fetchSKUPatternStart = () => {
    return crudActions.fetchStart();
};
export const fetchSKUPatternSuccess = (fetchSKUPatternCount, listSKUPatternCount) => {
    return crudActions.fetchSuccess(fetchSKUPatternCount, listSKUPatternCount);
};
export const fetchSKUPatternFail = () => {
    return crudActions.fetchFail();
};
export const fetchSKUPatternCount = (filterData) => {
    const rest = getAxiosInstance();
    return async (dispatch) => {
        dispatch(fetchSKUPatternStart());
        try {
            let countRes = await rest.post('sku-patterns/count', filterData);
            if (countRes.data && countRes.data.succeeded) {
                if (!countRes.data.result.data) {
                    dispatch(fetchSKUPatternSuccess(0, []));
                }
                return countRes.data.result.data;
            }
            dispatch(fetchSKUPatternFail());
            snackActions.snackBar({
                message: `${countRes && countRes.data ? countRes.data.message : 'Cannot fetch SKU patterns.'}`,
                options: {
                    variant: 'warning',
                },
            });
            return 0;
        } catch (error) {
            dispatch(fetchSKUPatternFail());
            snackActions.snackBar({
                message: `${error.message || 'Cannot fetch SKU patterns.'}`,
                options: {
                    variant: 'error',
                },
            });
            return 0;
        }
    };
};

export const fetchSKUPattern = (filterData) => {
    const rest = getAxiosInstance();
    return async (dispatch) => {
        dispatch(fetchSKUPatternStart());
        try {
            let listRes = await rest.post('sku-patterns/list', filterData);
            if (listRes.data && listRes.data.succeeded) {
                dispatch(fetchSKUPatternSuccess(filterData.count, listRes.data.result.data));
                return listRes.data.result.data;
            }
            dispatch(fetchSKUPatternFail());
            return [];
        } catch (error) {
            dispatch(fetchSKUPatternFail());
            return [];
        }
    };
};

// Load SKU pattern action creators
export const loadSKUPatternInit = () => {
    return crudActions.loadInit();
};
export const loadSKUPatternStart = () => {
    return crudActions.loadStart();
};
export const loadSKUPatternSuccess = (loadedSKUPattern) => {
    return crudActions.loadSuccess(loadedSKUPattern);
};
export const loadSKUPatternFail = (error) => {
    return crudActions.loadFail(error);
};
export const loadSKUPattern = (id) => {
    return async (dispatch) => {
        await crudActions.load(dispatch, id);
    };
};

export const createSKUPattern = (params) => {
    const rest = getAxiosInstance();
    return async () => {
        try {
            let res = await rest.post('/sku-patterns/create', params);
            if (res.data && res.data.succeeded) {
                snackActions.snackBar({
                    message: `Successfully created SKU pattern.`,
                    options: {
                        variant: 'success',
                    },
                });
                return res.data.result.data;
            }
            snackActions.snackBar({
                message: `${
                    res && res.data ? res.data.message : res && res.message ? res.message : 'Cannot create SKU pattern.'
                }`,
                options: {
                    variant: 'warning',
                },
            });
            return null;
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error',
                },
            });
            return null;
        }
    };
};

export const editSKUPattern = (params) => {
    const rest = getAxiosInstance();
    return async () => {
        try {
            let res = await rest.post('/sku-patterns/save', params);
            if (res.data && res.data.succeeded) {
                snackActions.snackBar({
                    message: `Successfully updated SKU pattern.`,
                    options: {
                        variant: 'success',
                    },
                });
                return res.data.result.data;
            }
            snackActions.snackBar({
                message: `${
                    res && res.data ? res.data.message : res && res.message ? res.message : 'Cannot edit SKU pattern.'
                }`,
                options: {
                    variant: 'warning',
                },
            });
            return null;
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error',
                },
            });
            return null;
        }
    };
};

// Bulk delete SKU patterns action creators
export const bulkDeleteSKUPatternsInit = () => {
    return crudActions.bulkDeleteInit();
};
export const bulkDeleteSKUPatternsStart = () => {
    return crudActions.bulkDeleteStart();
};
export const bulkDeleteSKUPatternsSuccess = (bulkDeleted) => {
    return crudActions.bulkDeleteSuccess(bulkDeleted);
};
export const bulkDeleteSKUPatternsFail = (error) => {
    return crudActions.bulkDeleteFail(error);
};
export const bulkDeleteSKUPatterns = (params) => {
    const rest = getAxiosInstance();
    return async (dispatch) => {
        dispatch(bulkDeleteSKUPatternsStart());
        try {
            let res = await rest.post('/sku-patterns/bulk-delete', params);
            if (res.data && res.data.succeeded) {
                dispatch(bulkDeleteSKUPatternsSuccess(res.data.result.data));
                snackActions.snackBar({
                    message: `Successfully deleted SKU patterns.`,
                    options: {
                        variant: 'success',
                    },
                });
                return;
            }
            dispatch(
                bulkDeleteSKUPatternsFail({
                    message: `${
                        res && res.data
                            ? res.data.message
                            : res && res.message
                            ? res.message
                            : 'Cannot bulk delete SKU patterns.'
                    }`,
                })
            );
            snackActions.snackBar({
                message: `${
                    res && res.data
                        ? res.data.message
                        : res && res.message
                        ? res.message
                        : 'Cannot bulk delete SKU patterns.'
                }`,
                options: {
                    variant: 'warning',
                },
            });
            return null;
        } catch (error) {
            dispatch(bulkDeleteSKUPatternsFail(error));
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error',
                },
            });
            return null;
        }
    };
};
